// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"JTMSCourseAttribute_searchContainer_tvjBr","filterInput":"JTMSCourseAttribute_filterInput_3hwof","headerContainer":"JTMSCourseAttribute_headerContainer_rqoXr"};